import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'playbook-notification-skeleton',
  templateUrl: './notification-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationSkeletonComponent {}
